import script from "./authorize.vue?vue&type=script&setup=true&lang=js"
export * from "./authorize.vue?vue&type=script&setup=true&lang=js"

import "./authorize.vue?vue&type=style&index=0&id=6916071c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6916071c"]])

export default __exports__